import { app, pages } from '@/config'
import { migratedPages } from '@/router/helpers/migrated-routes'
import { app as app3 } from '@vue3/configs'

const routes = [
  ...migratedPages,
  {
    path: pages.loyalty,
    name: app.routerName.loyalty,
    component: () => import('@/pages/Loyalty/index.vue'),
    meta: {
      auth: true,
      headerTabGroup: app3.routerName.homePage,
      checkAccessFromConfig: true,
      configName: 'loyaltyPoints'
    }
  },
  {
    path: pages.pointsHistory,
    name: app.routerName.pointsHistory,
    component: () => import('@/pages/PointsHistory/index.vue'),
    meta: {
      auth: true,
      headerTabGroup: app3.routerName.homePage,
      checkAccessFromConfig: true,
      configName: 'loyaltyPoints'
    }
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: () => import('@/pages/PageNotFound/index.vue'),
    meta: {
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.maintenance,
    name: app.routerName.maintenance,
    component: () => import('@/pages/MaintenancePage/index.vue'),
    meta: {
      hideHeaderNavigation: true
    }
  }
]

export default routes
